import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AutocompleteDropdownComponent } from "../../autocomplete-dropdown/autocomplete-dropdown.component";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Control } from "../../../models/dynamic-form";
import { ToggleComponent } from "../../common/toggle/toggle.component";
import { ChipInputComponent } from "../../common/chip-input/chip-input.component";
import { NgClass, NgIf } from "@angular/common";
import { MultiSelectComponent } from "../../select/multi-select.component";
import { DatePickerComponent } from "../../common/date-picker/date-picker.component";
import { DynamicFromDataType } from "../../../constants/dynamic-from-data-type";
import { DateRangePickerComponent } from "../../common/date-range-picker/date-range-picker.component";
import { CodeFormatDirective } from "../../../directives/code-input.directive";
import { NzCronExpressionComponent } from "ng-zorro-antd/cron-expression";
import { NzRadioComponent, NzRadioGroupComponent } from "ng-zorro-antd/radio";
import { DATE_CONFIG } from "../../../constants/app-constants";

@Component({
  selector: 'app-dynamic-input',
  standalone: true,
  imports: [
    AutocompleteDropdownComponent,
    ReactiveFormsModule,
    ToggleComponent,
    ChipInputComponent,
    MultiSelectComponent,
    DatePickerComponent,
    NgClass,
    NgIf,
    DateRangePickerComponent,
    CodeFormatDirective,
    NzCronExpressionComponent,
    NzRadioGroupComponent,
    NzRadioComponent
  ],
  templateUrl: './dynamic-input.component.html',
  styleUrl: './dynamic-input.component.scss'
})
export class DynamicInputComponent {
  @Input() control!: Control;
  @Input() form!: FormGroup;
  @Input() isControlReadOnly: boolean = false;
  @Input() isControlDisabled: boolean = false;

  @Output() onValueChange = new EventEmitter<{controlName: string, result: any, isCustomInput?: boolean}>();
  @Output() onValueCleared = new EventEmitter<any>();

  onChange(result: any, isCustomInput: boolean = false) {
    this.onValueChange.emit({
      controlName: this.control.label,
      result,
      isCustomInput
    })
  }

  onSuggestionSelected(event: any) {
    this.onChange(event, false);
  }

  onCustomInputSelected(event: any) {
    this.onChange(event, true);
  }

  onFormValueCleared() {
    this.onValueCleared.emit(this.control.label);
  }

  protected readonly DynamicFromConstants = DynamicFromDataType;
  protected readonly DATE_CONFIG = DATE_CONFIG;
}
